'use client';

import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/shadcn/dialog';
import { Textarea } from '@/shared/ui/shadcn/textarea';
import { Button } from '@/shared/ui/shadcn/button';

interface ConceptNotesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  note: string;
  onSave: (note: string) => void;
}

export function ConceptNotesDialog({
  open,
  onOpenChange,
  note,
  onSave,
}: ConceptNotesDialogProps) {
  const t = useTranslations('concept');
  const [localNote, setLocalNote] = useState(note);

  useEffect(() => {
    if (open) {
      setLocalNote(note);
    }
  }, [open, note]);

  const handleSave = () => {
    onSave(localNote);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t('notes.dialogTitle')}</DialogTitle>
        </DialogHeader>
        <Textarea
          value={localNote}
          onChange={(e) => setLocalNote(e.target.value)}
          placeholder={t('notes.placeholder')}
          className="min-h-[150px] resize-none"
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('notes.cancel')}
          </Button>
          <Button onClick={handleSave}>{t('notes.save')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
